<template>
  <div class="flex justify-around items-center p-0 mb-1 rounded" disabled>
    <input type="text" class=" w-full bg-gray-400 text-sm m-1 rounded px-1" v-model="manualEdit" :disabled="!editEntityConcerned"></input>
    <button class="focus:outline-none m-1" v-if="!editEntityConcerned" @click="editEntityConcernedAction">
      <i class="fas fa-edit text-xl text-blue-300 hover:text-blue-500"></i>
    </button>
    <button class="focus:outline-none m-1" v-else @click="submitEntityConcernedAction">
      <i class="fas fa-check-square text-xl text-green-300 hover:text-green-500"></i>
    </button>
    <button @click="deleteEntityConcerned(index)" class="border m-1 border-white flex-shrink-0 w-5 h-5 rounded-full bg-red-500 focus:outline-none hover:bg-red-700 flex items-center justify-center">
      <i class="fas fa-minus text-sm text-white"></i>
    </button>
  </div>
</template>

<script>
import { getTheWordCoordinate } from '@/helpers';

export default {
  props: [
    'index', 
    'value', 
    'deleteEntityConcerned', 
    'startEditingEntityConcerned',
    'finishEditingEntityConcerned'
  ],
  data() { 
    return {
      editEntityConcerned: false,
      manualEdit: '',
    }
  },
  created() {
    this.manualEdit = Array.isArray(this.value) ? this.value[0] : this.value;
    
    if (false) {
      this.editEntityConcerned = false;
    }
  },
  methods: {
    editEntityConcernedAction() {
      this.editEntityConcerned = true;
      this.startEditingEntityConcerned(0, 'entity');
    },
    submitEntityConcernedAction() {
      this.editEntityConcerned = false;
      this.finishEditingEntityConcerned();
    },
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        this.manualEdit = this.value;
      },
      deep: true
    },
  }
}
</script>

<style>

</style>